import {red, yellow, green, blue} from '@material-ui/core/colors';

export let calculateDayVelocityColour = (value) => {
    let statusColour = blue[500];

        const minValue = 250;
        const upperValue = 300;

        if (value >= 1 && value < minValue)
        {
            statusColour = lowValueColour;
        }
        else if ((value >= minValue) && (value < upperValue))
        {
            statusColour = midValueColour;
        }
        else if (value >= upperValue)
        {
            statusColour = highValueColour;
        }

    return statusColour;
}

export const lowValueColour = red[900];
export const midValueColour = yellow[900];
export const highValueColour = green[900];